interface IQuery {
  type?: string,
  handles?: string[],
  operator: 'OR' | 'AND',
  view?: string,
  json?: boolean,
  tags?: ITag[]
}

interface ITag {
  key: string,
  value: string
}

class Query {
  buildURL(query:IQuery) {
    return `${ window.location.origin }/search/${ this.getQueryString(query) }`;
  }

  getQueryString(query:IQuery) {
    let queryString = '';

    if (query.handles) {
      queryString += query.handles.reduce((acc:string, handle:string) => {
        acc += `handle:${ handle } ${ query.operator } `;
        return acc;
      }, '');
    }

    if (query.tags) {
      queryString += query.tags.filter(tag => tag.value !== '').reduce((acc:string, tag:ITag) => {
        acc += `tag:${ tag.key }: ${ tag.value } ${ query.operator } `;
        return acc;
      }, '');
    }

    if (query.type) queryString += `&type=${ query.type }`;
    if (query.view) queryString += `&view=${ query.view }`;

    return encodeURI(`?q=${ queryString }`);
  }
}

export default new Query();